//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setting_obj } from '~/settings/setting';
import { needXssKeys } from '~/utils/constants';
import { replaceToOriginStr, formatPath, toTagPage, debounce } from '~/utils/tools';
import { handleCopy, handlePraise } from '~/utils/userTools';
import LazyLoad  from '../lazy-load.vue'
import avatar from '@/components/avatar.vue';
import { handleUserBehaviorByType } from '@/components/subscription/subscription.js';

const statusObj = {
  1: {
    text: '审核中',
    class: 'processing',
  },
  2: {
    text: '审核未通过',
    class: 'failed',
  },
  3: {
    text: '已下架',
    class: 'unpub',
  },
};
let lastMsg;
export default {
  components: { avatar, LazyLoad },
  props: {
    cardType: {
      type: String,
      default: 'feed',
    },
    type: {
      type: String,
      default: 'resource',
    },
    showMask: {
      type: Boolean,
      default: false,
    },
    resourceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    action_position: {
      type: String,
      default: 'community',
    },
    action_type: {
      type: String,
      default: '',
    },
    active_id: {
      type: Number,
    },
    active_name: {
      type: String,
      default: '',
    },
    action_detail: {
      type: Number,
    },
    is_activity: {
      type: Boolean,
      default: false,
    },
    useOld: {
      type: Boolean,
      default: false,
    },
    needHover: {
      type: Boolean,
      default: false,
    },
    search_key: {
      type: String,
      default: '',
    },
    page_type: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      imageCdnPath: setting_obj.imageCdnPath,
      btnJump: false,
      favorite: false,
      favoriteCount: 0,
      copyCount: 0,
      resourceLabels: [], // 资源对应tag
    };
  },
  computed: {
    formatResourceInfo() {
      const info = { ...this.resourceInfo };
      const keys = Object.keys(info).filter((key) => needXssKeys.includes(key));
      keys.forEach((key) => {
        if (!info[key]) return;
        if (Array.isArray(info[key])) {
          info[key] = info[key].map(replaceToOriginStr);
        } else if (typeof info[key] === 'string') {
          info[key] = replaceToOriginStr(info[key]);
        }
      });
      return info;
    },
    statusObj() {
      return statusObj[this.formatResourceInfo.status];
    },
    isShowView() {
      return this.cardType !== 'like' && !this.showMask;
    },
    isShowAuthor() {
      return this.cardType === 'feed';
    },
    coverUrl() {
      const { cover_url } = this.formatResourceInfo;
      const path = formatPath(cover_url, setting_obj.imageCdnPath);
      return path;
    },
    _blank_url() {
      if (this.type === 'activity') {
        return `/community/activity/resource?from=card&act_id=${this.active_id}&res_id=${this.formatResourceInfo.res_id}`;
      }
      if(this.type === 'media'){
         return `/community/media/resource/${this.formatResourceInfo.res_id}?from=card`;
      }

      return `/community/resource/${this.formatResourceInfo.res_id}?from=card`;
    },
    favoriteAllCount() {
      return (this.formatResourceInfo.like_cnt || 0) + this.favoriteCount;
    },
    copyAllCount () {
      return (this.formatResourceInfo.copy_cnt || 0) + this.copyCount;
    },
     hotLabelList() {
      return this.formatResourceInfo?.res_hot_label_arr || []
    }
  },
  watch: {
    resourceInfo() {
      this.initInfo();
    },
  },
  created() {
    this.initInfo();
    this.handleDebounceCopy = debounce(this.handleCopyFn,500,true)
  },
  mounted() {
    // const imageView = this.$refs[this.formatResourceInfo.res_id]
    // this.destroyObserver = lazilyLoadImage(imageView, () => {
    //   // 加载
    //   imageView.src = this.coverUrl
    // }, { rootMargin: '30px 0px 0px 0px' })
  },
  methods: {
    initInfo() {
      this.favorite = this.resourceInfo.favorite;
      this.favoriteCount = this.favorite && !this.resourceInfo.like_cnt ? 1 : 0;
      this.copyCount = 0;
    },
    handleEnter() {
      if (window.localStorage.getItem('CARD_HOVER') || this.useOld) return;
      window.localStorage.setItem('CARD_HOVER', '1');
      this.btnJump = true;
    },
    goTagPage(label) {
      toTagPage(label)
      this.setTagSensors()
    },
    setTagSensors(){
      this.$sensors.track('event_click', {
        action_position: 'community',
        action_parameter1: 'cover_tag',
      });
    },
    async handlePraise() {
      if (this.pending) return;
      this.pending = true;
      try {
        await handlePraise({ res_id: this.formatResourceInfo.res_id, action_type: this.favorite ? 2 : 1  });
        this.favorite = !this.favorite;
        this.favoriteCount += this.favorite ? 1 : -1;
        this.setPraiseSensors(this.favorite)
      } catch {
        //
      } finally {
        this.pending = false;
      }
    },
    async handleCopyFn() {
      if (this.copying) return;
      this.copying = true
      try {
        await handleCopy(this.formatResourceInfo.res_id);
        handleUserBehaviorByType('resource');
        this.copyCount += 1;
        if (lastMsg) lastMsg.close();
        lastMsg = this.$message({
          message: '已复制到工作台草稿箱，可前往查看',
          type: 'success',
          duration: 5000,
        });
      } catch {
        //
      } finally {
        this.copying = false;
      }
    },
    goResourceDetail() {
      if (this.formatResourceInfo.status) return;
      if (this.action_position) {
        const sensorParams = {
          action_position: this.action_position,
          resource_id: this.formatResourceInfo.res_id,
          resource_name: this.formatResourceInfo.res_name,
          action_detail: this.action_detail,
          active_id: this.active_id || '',
          active_name: this.active_name || '',
        };
        if (this.action_type) {
          sensorParams.action_type = this.action_type;
        }
        if(this.search_key) {
          sensorParams.action_parameter0 = this.search_key
        }
        // 根据来源增加访问社区文件埋点
        this.$sensors.track('get_resource', sensorParams);
        this.$emit('handelSubs');
      }
    },
    goUser() {
      const routeData = this.$router.resolve({
        name: 'profile-id',
        params: { id: this.formatResourceInfo.author_id },
      });
      window.open(routeData.href, '_blank');
    },
    clickResource(e) {
      if (this.showMask) e.preventDefault();
    },
    setPraiseSensors(favorite) {
      const type = favorite ? 'add' : 'remove'
      const sensorsParams = {
        action_position: this.page_type,
        action_parameter1: 'favorite',
        resource_id: this.formatResourceInfo.res_id,
        resource_name: this.formatResourceInfo.res_name,
        action_type: type
      }
      const isProfile = this.page_type === 'community_profile'
      if(isProfile) {
        const activeTab = this.$route.query?.tab || ''
        const formateActiveTab = activeTab === 'save' ? 'favorite' : activeTab
        sensorsParams.action_parameter0 = formateActiveTab
      }
      this.$sensors.track('event_click', sensorsParams);
    }
  },
};
